import { useEffect, useState } from 'react';
import { useSubscription } from '../hooks/useSubscription';
import { LEAD_JOB_SALES_EVENT } from '../lib/billing/leadJobSalesModal';
import type { LeadJobSalesVariant } from '../lib/billing/leadJobSalesGate';
import TalkToSalesModal from './TalkToSalesModal';

export default function LeadJobSalesHost() {
  const { entitlements } = useSubscription();
  const [variant, setVariant] = useState<LeadJobSalesVariant | null>(null);

  useEffect(() => {
    const onSales = (event: Event) => {
      const detail = (event as CustomEvent<LeadJobSalesVariant>).detail;
      if (detail === 'research_expired' || detail === 'research_quota') {
        setVariant(detail);
      }
    };
    window.addEventListener(LEAD_JOB_SALES_EVENT, onSales);
    return () => window.removeEventListener(LEAD_JOB_SALES_EVENT, onSales);
  }, []);

  return (
    <TalkToSalesModal
      isOpen={Boolean(variant)}
      onClose={() => setVariant(null)}
      variant={variant || 'research_quota'}
      calendarUrl={entitlements.salesCalendarUrl}
      showBillingLink={false}
    />
  );
}
